import script from "./UiTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTableCard.vue?vue&type=script&setup=true&lang=js"

import "./UiTableCard.vue?vue&type=style&index=0&id=4928d2ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4928d2ad"]])

export default __exports__